import ScrollMagic from 'scrollmagic';

document.addEventListener('DOMContentLoaded', () => {

    const controller = new ScrollMagic.Controller;

    function apearScene(el, startAnimation, cls) {

        el.each(function () {

            new ScrollMagic.Scene({
                triggerElement: this,
                // duration: '100%', // view port height good for responsive animations
                triggerHook: startAnimation,
                reverse: false // animations will happens only once
            })
                .setClassToggle(this, cls)
                .addTo(controller);
        });
    }

    function appendClass(selector, cls) {

        if (selector.length) {

            selector.each(function (index) {

                if (!$(this).hasClass(cls)) {

                    selector.eq(index).addClass(cls);

                }

            })

        }

    }

    // set transition-delay for card element only when it shows

    function setTransitionDelay(selector) {

        let cardElement = $(selector);

        if (cardElement.length) {

            cardElement.each(function (index) {

                cardElement.eq(index).css('transition-delay', index * 0.1 + 's');

            });

        }

    }

    setTransitionDelay('.card');
    setTransitionDelay('.card-brand');


    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {

        document.documentElement.addEventListener('isLoaded', () => {

            apearScene($('.line-vertical'), 0.7, 'show');
            apearScene($('.card-list'), 0.8, 'show');
            apearScene($('.section--brand'), 0.8, 'show');
            apearScene($('.info-box--centered'), 0.8, 'show');
            apearScene($('.slider--sale'), 0.8, 'show-slider');
            apearScene($('.section--newsletter .input-group'), 0.8, 'show');
            apearScene($('.content--stick'), 0.8, 'animate-content');
            apearScene($('.section--news .info-action'), 0.8, 'show');
            apearScene($('.content__title'), 0.8, 'show');
            apearScene($('.content__head'), 0.9, 'show');
            apearScene($('.sub-head .info-box--cover'), 1, 'show');
            apearScene($('.sub-head__action'), 1, 'show');
            apearScene($('.content-action'), 0.8, 'show');
            apearScene($('.contact-box'), 0.7, 'show');
            apearScene($('.content--additional'), 0.8, 'show');
            apearScene($('.accessories-item'), 0.7, 'show-content');
            apearScene($('.image-box--dual'), 0.7, 'show');
            apearScene($('.section--news-article .info-box'), 0.8, 'show');

        });

    } else {

        appendClass($('.line-vertical'), 'show');
        appendClass($('.card-list'), 'show');
        appendClass($('.section--brand'), 'show');
        appendClass($('.info-box--centered'), 'show');
        appendClass($('.slider--sale'), 'show-slider');
        appendClass($('.section--newsletter .input-group'), 'show');
        appendClass($('.content--stick'), 'animate-content');
        appendClass($('.section--news .info-action'), 'show');
        appendClass($('.content__title'), 'show');
        appendClass($('.content__head'), 'show');
        appendClass($('.sub-head .info-box--cover'), 'show');
        appendClass($('.sub-head__action'), 'show');
        appendClass($('.content-action'), 'show');
        appendClass($('.contact-box'), 'show');
        appendClass($('.content--additional'), 'show');
        appendClass($('.accessories-item'), 'show-content');
        appendClass($('.image-box--dual'), 'show');
        appendClass($('.section--news-article .info-box'), 'show');

    }

    // for edit mode

    if ($('html').hasClass('ccm-edit-mode')) {
        appendClass($('.line-vertical'), 'show');
        appendClass($('.card-list'), 'show');
        appendClass($('.section--brand'), 'show');
        appendClass($('.info-box--centered'), 'show');
        appendClass($('.slider--sale'), 'show-slider');
        appendClass($('.section--newsletter .input-group'), 'show');
        appendClass($('.content--stick'), 'animate-content');
        appendClass($('.section--news .info-action'), 'show');
        appendClass($('.content__title'), 'show');
        appendClass($('.content__head'), 'show');
        appendClass($('.sub-head .info-box--cover'), 'show');
        appendClass($('.sub-head__action'), 'show');
        appendClass($('.content-action'), 'show');
        appendClass($('.contact-box'), 'show');
        appendClass($('.content--additional'), 'show');
        appendClass($('.accessories-item'), 'show-content');
        appendClass($('.image-box--dual'), 'show');
        appendClass($('.section--news-article .info-box'), 'show');
    }

});


// WEBPACK FOOTER //
// ./scripts/scrollmagic.js